import { AccountApi, AdjudicationApi, BiometricDataApi, Configuration, ConfigurationParameters, ExceptionsApi, ImagesApi, JanusApi, LicensingApi, ManagementApi, OperationsApi, SubjectsApi } from "neurotec-megamatcherid-management-client";
import { AdjudicationApi as AdjudicatorAdjudicationApi, ManagementApi as AdjudicatorManagementApi} from "neurotec-megamatcherid-management-client-adjudicator";
import { APIsActionType, APIsActions } from "./actions";
import { APIsState, UnifiedAdjudicationApi, UnifiedManagementApi, wrapApi } from "./state";
import { AuthenticationRole } from "../Authentication/types";

export const apisReducer = (state: APIsState, action: APIsActions): APIsState => {
    switch (action.type) {
        case APIsActionType.SetUpAdminAPIs:
            return {
                ...state,
                JanusApi: new JanusApi(new Configuration(action.configuration)),
                ManagementApi: wrapApi(new ManagementApi(new Configuration(action.configuration)) as UnifiedManagementApi, AuthenticationRole.ROLE_ADMIN),
                SubjectsApi: new SubjectsApi(new Configuration(action.configuration)),
                OperationsApi: new OperationsApi(new Configuration(action.configuration)),
                ImagesApi: new ImagesApi(new Configuration(action.configuration)),
                LicensingApi: new LicensingApi(new Configuration(action.configuration)),
                ExceptionsApi: new ExceptionsApi(new Configuration(action.configuration)),
                BiometricDataApi: new BiometricDataApi(new Configuration(action.configuration)),
                AccountsApi: new AccountApi(new Configuration(action.configuration)),
                AdjudicationApi: wrapApi(new AdjudicationApi(new Configuration(action.configuration)) as UnifiedAdjudicationApi, AuthenticationRole.ROLE_ADMIN),
            }
        case APIsActionType.SetUpAdjudicatorAPIs:
            return {
                ...state,
                AdjudicationApi: wrapApi(new AdjudicatorAdjudicationApi(new Configuration(action.configuration)) as UnifiedAdjudicationApi, AuthenticationRole.ROLE_ADJUDICATOR),
                ManagementApi: wrapApi(new AdjudicatorManagementApi(new Configuration(action.configuration)) as UnifiedManagementApi, AuthenticationRole.ROLE_ADJUDICATOR),
            }
        default: 
            return state
    }
}

export const setUpAdminApis = (configuration: ConfigurationParameters) => {
    return {
        type: APIsActionType.SetUpAdminAPIs,
        configuration
    }
}

export const setUpAdjudicatorApis = (configuration: ConfigurationParameters) => {
    return {
        type: APIsActionType.SetUpAdjudicatorAPIs,
        configuration
    }
}